import { PollSubType } from 'api/api.types';
import classNames from 'classnames';
import { MAP_COLOR_STEPS } from 'lib/Map/getMapColorPoll';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  yesCount: number;
  subtype: PollSubType;
}

const MapKey = ({ yesCount, subtype }: Props) => {
  const { t } = useTranslation('wap');

  const getIsHovering = (index: number) => {
    if (!yesCount) {
      return false;
    }

    return (
      (MAP_COLOR_STEPS[index] || 0) >= yesCount &&
      yesCount > (MAP_COLOR_STEPS[index + 1] || 0)
    );
  };

  const headingI18nKey = subtype === 'tie_break' ? 'vi_votes' : 'yes_votes';

  return (
    <div className="mapkey" aria-hidden>
      <h3 className="h4">{t(headingI18nKey)}</h3>
      <div className="mapkey__fragments">
        {MAP_COLOR_STEPS.map((step, index) => (
          <div key={step} className="mapkey__fragment">
            <div
              className={classNames('mapkey__fragment-bar', {
                'mapkey__fragment-bar--hovered': getIsHovering(index),
              })}
            />
            <div className="mapkey__label">{MAP_COLOR_STEPS[index]}</div>
            {index === MAP_COLOR_STEPS.length - 1 && (
              <div className="mapkey__label mapkey__label-zero">{0}</div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default MapKey;
